/** The W3C traceparent header sent with every gateway request in a chat. */
export const toTraceparent = (chatId: string): string =>
  `00-${chatId.replace(/-/g, '')}-4fe7d85c49cf1379-01`;
